export default __webpack_public_path__ + "static/media/added-to-watchlist-new.27634c29.svg";